<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="mt-4">
        <Activation />
        <b-row class="mt-md-5">
            <b-col cols="3" class="desktop">
                <p>Filter by</p>
                <div class="card sidecard">
                    <b-form-group class=" mb-4" label-for="name">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="1" icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input @change="getServices(page)" type="text" v-model="name" placeholder="Business name"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>

            </b-col>
            <b-col cols="3" class="mobile p-4">
                <b-icon @click="openMenu" icon="list" scale="2"></b-icon>
                <div class="slide-menu card sidecard" id="slidmenu" v-click-outside="hideSidemenu">
                    <p>Filter by</p>

                    <b-form-group class=" mb-4" label-for="name">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="1" icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input @change="getServices(page)" type="text" v-model="name" placeholder="business name"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
            </b-col>

            <b-col cols="12" md="9">
                <div v-if="businesses.length > 0">
                    <p class="mb-4 d-flex ml-2 justify-content-between">
                        <span>
                            Per page:
                            <select class="" v-model="no_per_page" @change="getServices(page)">
                                <option value="9" selected>9</option>
                                <option value="27">27</option>
                                <option value="54">54</option>
                                <option value="100">100</option>
                            </select> items
                        </span>
                        <span>{{page}} of {{rows}} results</span>
                    </p>
                    <b-row class="">
                        <b-col v-for="(business, index) in businesses" :key='index' cols="12" md="4" class="mb-3" style="padding-right:0">
                            <ServiceCard @handleClick="showServices(business)" :image='getImage(business)' :name="business.name" :services="business.services" :zoom='12' :center="business.center" />
                        </b-col>
                    </b-row>
                    <div>
                        <b-pagination v-model="page" :total-rows="rows" @change="getServices" :per-page="no_per_page"></b-pagination>
                    </div>
                </div>
                <div class="mt-4" v-if="loading">
                    <content-loader :speed="2" :height="400" :width="600">
                        <rect x="537" y="9" rx="2" ry="2" width="140" height="10" />
                        <rect x="14" y="30" rx="2" ry="2" width="667" height="11" />
                        <rect x="12" y="58" rx="2" ry="2" width="211" height="211" />
                        <rect x="240" y="57" rx="2" ry="2" width="211" height="211" />
                        <rect x="467" y="56" rx="2" ry="2" width="211" height="211" />
                        <rect x="12" y="283" rx="2" ry="2" width="211" height="211" />
                        <rect x="240" y="281" rx="2" ry="2" width="211" height="211" />
                        <rect x="468" y="279" rx="2" ry="2" width="211" height="211" />
                        <circle cx="286" cy="536" r="12" />
                        <circle cx="319" cy="535" r="12" />
                        <circle cx="353" cy="535" r="12" />
                        <rect x="378" y="524" rx="0" ry="0" width="52" height="24" />
                        <rect x="210" y="523" rx="0" ry="0" width="52" height="24" />
                        <circle cx="210" cy="535" r="12" />
                        <circle cx="428" cy="536" r="12" />
                    </content-loader>
                </div>
                <div v-if="businesses.length == 0 && !loading">
                    No services yet, check back later
                </div>
            </b-col>

        </b-row>
        <b-modal id="service-list" hide-header centered title="Services" hide-footer>
            <div class="text-center">
                <p class="text-capitalize">
                    What we do better than anyone else around here
                </p>
                <p>
                    <b-icon font-scale="3" class="culture-primary" icon="bag"></b-icon>
                </p>
                <div class="mb-3 font-weight-bold">
                    List of Services
                </div>

                <p class="font14" v-for="(service, index) in business.services" :key='index'>
                    <b-icon icon="tag"></b-icon> {{service.title}}
                </p>
                <hr style="border-top:3px solid rgba(0, 0, 0, 0.1);">
                <div class="font10">
                    Address: {{business.address}}
                </div>
                <div class="font10">
                    Contact: {{business.phone}}
                </div>
                <div class="font10">
                    Email: {{business.email}}
                </div>

                <div class="mt-4 font10">
                    Powered by
                </div>
                <div class="font10">
                    Culture Square LLC
                </div>

            </div>
        </b-modal>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import ServiceCard from "@/components/ServiceCard.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import vClickOutside from 'v-click-outside'
import 'vue-simple-range-slider/dist/vueSimpleRangeSlider.css';
import {
    ContentLoader
} from "vue-content-loader";

import axios from "axios";
import {
    getBaseUrl
} from "../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'shop',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        ContentLoader,
        ServiceCard,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Services",
            name: '',
            subText: "Discover unique local services from around the world with their unique stories",
            fadedText: "Businesses",
            img: require("../../assets/images/default_company_logo.png"),
            showMenu: false,
            loading: true,
            businesses: [{
                services: [],
            }],
            pagination: {},
            page: 1,
            no_per_page: 9,
            business: {}
        }
    },
    beforeMount() {
        this.getServices();
    },
    computed: {
        rows() {
            return this.pagination.total
        },
    },

    methods: {
        getImage(business){
            return business.image ===  '' ? this.img : business.image;
        },
        async getServices(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/services`,
                    params: {
                        page: page,
                        name: this.name,
                        no_per_page: this.no_per_page,
                    },
                    method: "GET",
                })
                this.loading = false;
                this.businesses = resp.data.data;
                this.businesses.forEach(business => {
                    business.center = {
                        lat: Number(business.lat),
                        lng: Number(business.long),
                    };
                });
                this.pagination = resp.data.meta
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        showServices(business) {
            this.$bvModal.show("service-list")
            this.business = business
        },
        openMenu() {
            var slide = document.getElementById('slidmenu')
            if (slide.style.marginLeft === '-360px') {
                slide.style.marginLeft = '-24px'

            } else {
                slide.style.marginLeft = '-360px'
            }
        },
        hideSidemenu() {
            var slide = document.getElementById('slidmenu')
            slide.style.marginLeft = '-360px'
        }
    }

}
</script>

<style lang="scss" scoped>
.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
    width: 100%;
}

.form-control {
    border-radius: 0 8px 8px 0 !important;
    height: calc(2em + 0.75rem + 15px) !important;

}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.borderd {
    border: 1px solid #ccc !important;
    border-radius: 5px !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    margin: 13px auto
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.sidecard {
    box-shadow: 2px 6px 19px rgb(0 0 0 / 3%);
    border-radius: 4px;
    padding: 16px !important;
    border: none !important;
}

.simple-range-slider {
    width: auto !important;

}

.flex {
    display: flex;
    justify-content: space-between;
}

.slide-menu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: -340px;
    width: 328%;
    top: 0px;
    padding-left: 16px;
    transition: all 0.5s ease-in-out;
}
</style>
